import Reflux from "reflux";
import Freezer from "freezer-js";
import GeneralStatusUpdateActions from "../react_actions/general_status_update_actions";

const initialState = {
  creationInProgress: false,
  saveInProgress: false,
};

const state = new Freezer({});

const getState = () => state.get();

export default Reflux.createStore({

  listenables: GeneralStatusUpdateActions,

  getInitialState: getState,
  getState,

  setCreationInProgress(value) {
    this.setState({ creationInProgress: value });
  },

  setState(state, options={}) {
    const newState = this.getState().set(state);
    if(options.trigger !== false) {
      this.trigger(newState);
    }
  },

  onSave(updateText) {
    const data = {
      user_status: {
        body: updateText,
      },
    };
    $j.post("/user_status.json", data)
      .done(() => {
        this.onCloseCreationDialog();
      })
      .fail(() => {
        window.alert("An error has occurred. Please try again");
      })
      .always(() => {
        this.setState({ saveInProgress: false });
      });
    this.setState({ saveInProgress: true });
  },

  onOpenCreationDialog() {
    this.setCreationInProgress(true);
  },

  onCloseCreationDialog() {
    this.setCreationInProgress(false);
  },

  reset() {
    getState().reset(initialState);
  },

});
